<template>
  <div class="container">
    <div class="header">
      <div class="bg-wrapper">
        <div class="bg-img-wrapper" v-if="store.mb_title_img">
          <img class="bg-image" :src="store.mb_title_img">
        </div>
        <div class="bg-mask"></div>
      </div>
      <div class="content-wrapper">
        <div class="content">
          <div class="store_name">{{store.store_name}}</div>
        </div>
        <div class="follow_panel">
          <div class="follow_button" @click="toggleFavorite">
            <i class="iconfont" :class="{'active':store.is_favorate}"  v-html="favoriteIco"></i>
            {{favoriteName}}
          </div>
        </div>
        <i class="header-more iconfont" @click="popupMore">&#xe680;</i>
      </div>
    </div>

    <header-more v-show="popupVisible"></header-more>

    <div v-for='(editablePageConfig,key) in editablePageConfigList' :key="key">
      <model1 v-if='editablePageConfig.editable_page_model_id==1' v-bind:editablePageConfig="editablePageConfig"></model1>
      <model2 v-if='editablePageConfig.editable_page_model_id==2' v-bind:editablePageConfig="editablePageConfig"></model2>
      <model6 v-if='editablePageConfig.editable_page_model_id==6' v-bind:editablePageConfig="editablePageConfig"></model6>
      <model12 v-if='editablePageConfig.editable_page_model_id==12' v-bind:editablePageConfig="editablePageConfig"></model12>
      <model13 v-if='editablePageConfig.editable_page_model_id==13' v-bind:editablePageConfig="editablePageConfig"></model13>
      <model14 v-if='editablePageConfig.editable_page_model_id==14' v-bind:editablePageConfig="editablePageConfig"></model14>
      <model15 v-if='editablePageConfig.editable_page_model_id==15' v-bind:editablePageConfig="editablePageConfig"></model15>
      <model19 v-if='editablePageConfig.editable_page_model_id==19' v-bind:editablePageConfig="editablePageConfig"></model19>
      <model20 v-if='editablePageConfig.editable_page_model_id==20' v-bind:editablePageConfig="editablePageConfig"></model20>
    </div>
    <common-store-footer :store_id="store.store_id"></common-store-footer>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { getEditablePageConfigList } from '../../../api/homeindex'
import CommonStoreFooter from '../common/CommonStoreFooter'
import Model1 from '../special/editable_page_model/Model1'
import Model2 from '../special/editable_page_model/Model2'
import Model6 from '../special/editable_page_model/Model6'
import Model12 from '../special/editable_page_model/Model12'
import Model13 from '../special/editable_page_model/Model13'
import Model14 from '../special/editable_page_model/Model14'
import Model15 from '../special/editable_page_model/Model15'
import Model19 from '../special/editable_page_model/Model19'
import Model20 from '../special/editable_page_model/Model20'
import HeaderMore from '../../HeaderMore'
import { getStoreInfo } from '@/api/homestoredetail'
import { addFavoriteStore, delFavoriteStore } from '@/api/memberFavorite'

export default {
  name: 'StoreSpecialIndex',
  data () {
    return {
      editablePage: {},
      editablePageConfigList: [],
      store: {
        store_id: this.$route.query.id ? this.$route.query.id : ''
      },
      popupVisible: false // 弹出更多
    }
  },
  props: ['pagePath', 'itemId'],
  components: {
    HeaderMore,
    Model1,
    Model2,
    Model6,
    Model12,
    Model13,
    Model14,
    Model15,
    Model19,
    Model20,
    CommonStoreFooter
  },
  computed: {
    ...mapState({
      special: state => state.home.special
    }),
    favoriteIco () {
      return this.store.is_favorate ? '&#xe64d;' : '&#xe64e;'
    },
    favoriteName () {
      return this.store.is_favorate ? 'Collected' : 'Collect'
    }
  },
  mounted () {
  },
  created: function () {
    var special_id = this.$route.query.special_id
    if (!special_id && !this.pagePath) {
      Toast('Missing parameters')
      return
    }
    getEditablePageConfigList(special_id, this.pagePath, this.itemId, this.store.store_id).then(res => {
      this.editablePage = res.result.editable_page
      this.editablePageConfigList = res.result.editable_page_config_list
      if (this.pagePath) {
        this.saveHomeSpecial({ pagePath: this.pagePath, storeId: this.store.store_id, itemId: this.itemId, editablePage: this.editablePage, editablePageConfigList: this.editablePageConfigList })
      }
    }).catch(function (error) {
      Toast(error.message)
    })

    getStoreInfo(
      this.store.store_id, this.token
    ).then((res) => {
      // 修改当前页面标题
      document.title = res.result.store_info.store_name

      this.store = res.result.store_info
      this.seckill_goods_list = res.result.seckill_goods_list
      this.rec_goods_list = res.result.rec_goods_list
      if (this.store.is_platform_store) {
        this.fetchConfig({}).then(
          response => {
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }).catch(function (error) {
    })
  },
  methods: {
    ...mapMutations({
      saveHomeSpecial: 'saveHomeSpecial'
    }),
    // 弹出更多
    popupMore () {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    },
    toggleFavorite () {
      if (!this.store.is_favorate) {
        addFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      } else {
        delFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }
  }
}
</script>
<style scoped>
.dot {
  position:absolute;
  width:.5rem;
  height:.5rem;
  background:red;
  border-radius:50%;
  top:.2rem;
  right:0;
}
.header {
  background: rgba(7,17,27,.5);
  color: #fff;
  overflow: hidden;
  position: relative;
  background-position: center;
  background-size: auto 100%;
}
.header .content-wrapper {
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding:0.8rem 0.4rem;
  position: relative;
}
.header .content-wrapper .content {
  position:relative;
  min-width: 53.333vw;
  width: 53.333vw;
  height: 8.533vw;
  overflow: hidden;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  -webkit-align-items: center;
  align-items: center;
  font-weight: 700;
  font-size: 3.733vw;
}
.header .content-wrapper .content .store_name {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.follow_panel {
  position:absolute;
  top:1rem;
  right:2rem;
}
.follow_panel .follow_button {
  display:block;
  background:#e93b3d;
  border-radius:2.5rem;
  padding:0 0.4rem;
  line-height:1.2rem;
  font-size:0.6rem;
  color:#fff;
}
.follow_panel .follow_button i {
  line-height:1.2rem;
}
.follow_panel .follow_number {
  text-align:center;
  line-height:0.7rem;
  font-size:0.5rem;
  color:#fff;
  margin-top:0.1rem;
}
.header-more {
  width:2rem;
  height:2rem;
  line-height:2rem;
  position:absolute;
  /*top:0.5rem;*/
  right:0;
  color:#fff;
  text-align:center;
  font-size:1rem;
}
.header .bg-wrapper{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  overflow: hidden;
}
.header .bg-wrapper .bg-img-wrapper{
  width: 100%;
  height: 100%;
}
.header .bg-wrapper .bg-img-wrapper .bg-image{
  display: block;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: cover;
}
.header .bg-wrapper .bg-mask{
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  z-index: 0;
  background-image: linear-gradient(rgba(0,0,0,.4),rgba(0,0,0,.9));
}
</style>
